import { render, staticRenderFns } from "./RequestValidationModal.vue?vue&type=template&id=54441b26&scoped=true"
import script from "./RequestValidationModal.vue?vue&type=script&lang=js"
export * from "./RequestValidationModal.vue?vue&type=script&lang=js"
import style0 from "./RequestValidationModal.vue?vue&type=style&index=0&id=54441b26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54441b26",
  null
  
)

export default component.exports